/**
 * Which Sentry environment and release a browser event belongs to — the
 * frontend twin of utils/sentry_config.py, resolved from build-time env.
 *
 * Railway PR environments fork `pull-request` → `development` and inherit its
 * Sentry variables, so a preview build would report as `development` (or, with
 * the Dockerfile's old `production` default, as production). A Railway PR
 * environment is always `preview`; the Railway environment name rides along
 * as the `railway_environment` tag. See docs/SENTRY_SETUP.md.
 */
export const PREVIEW_ENVIRONMENT = 'preview';
export const DEFAULT_ENVIRONMENT = 'development';

// Railway names PR environments "<project>-pr-<number>" (e.g. Hestia-pr-356).
const RAILWAY_PR_ENVIRONMENT = /-pr-\d+$/;

const read = (env, key) => (env?.[key] || '').trim();

/**
 * @param {Record<string, string|undefined>} env - normally import.meta.env
 * @returns {string}
 */
export function resolveSentryEnvironment(env) {
  const railway = read(env, 'VITE_RAILWAY_ENVIRONMENT_NAME');
  if (RAILWAY_PR_ENVIRONMENT.test(railway)) return PREVIEW_ENVIRONMENT;
  return read(env, 'VITE_SENTRY_ENVIRONMENT') || railway || DEFAULT_ENVIRONMENT;
}

/**
 * @param {Record<string, string|undefined>} env
 * @returns {string|undefined} undefined lets the SDK send no release
 */
export function resolveSentryRelease(env) {
  return read(env, 'VITE_SENTRY_RELEASE') || undefined;
}

/**
 * @param {Record<string, string|undefined>} env
 * @returns {Record<string, string>} tags applied to every event
 */
export function resolveSentryTags(env) {
  const railway = read(env, 'VITE_RAILWAY_ENVIRONMENT_NAME');
  return railway ? { railway_environment: railway } : {};
}
